import axios from 'axios';
import { API_HEADER_AUTH } from '../constants/apiConstant';


const API_BASE_URL = 'https://techsolutionsservice.ustdev.com'
const SUPPLIERS_URL = `${API_BASE_URL}/suppliers`;

export const getSupplierDetails = async (supplierId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${supplierId}`,{headers:{
      Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
    }});
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data.message : error.message);
  }
};

export const fetchSuppliers = async () => {
  try {
    const response = await axios.get(SUPPLIERS_URL,{
      headers:{
        Authorization:`Bearer ${sessionStorage.getItem("authToken")
        }`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || error.message);
  }
};

export const submitSupplierData = async (data) => {
  try {
    const response = await axios.post(SUPPLIERS_URL, data,{
      headers:{
        Authorization:`Berear ${sessionStorage.getItem("authToken")}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || error.message);
  }
};
